import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/arrow-down-small",
  "use": "app/arrow-down-small-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/arrow-down-small\"><path d=\"M11.796 13.888L7.104 9.256a.895.895 0 00-1.253 0 .867.867 0 000 1.238l5.318 5.25a.895.895 0 001.253 0l5.318-5.25a.867.867 0 000-1.238.895.895 0 00-1.253 0l-4.691 4.632z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol